var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"common_content"},[(_vm.titleHide)?_c('div',{staticClass:"top_title"},[_c('h3',[_vm._v(_vm._s(this.$route.meta.title))]),_c('span',{staticClass:"top_title_span"})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }